module.exports = __webpack_public_path__ + "img/36.5c8be908.jpg";